import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { Jumbo } from "../../components/jumbo";
import { Teasers } from "../../components/teaser";
import { blogCategories, initialBlogResponse, labels, resultsClass } from './blogOverviewState';
import { Pager } from "../../../../Shared/components/Pager";
export const BlogOverviewLayout = (props)=>{
    const { headerTitle, description, phImageUrl, phImageUrlFallback, phImageUrlLarge, imageAlt, blogpostLoader, currentPage, pageSize, selectedCategory, setPage, setCategory, key } = props;
    const { posts, totalResults } = blogpostLoader.kind == 'loaded' || blogpostLoader.kind == 'loading' ? blogpostLoader.value : initialBlogResponse;
    const pager = totalResults ? Pager({
        currentPage,
        pageSize,
        totalResults,
        setPage,
        containerSize: 'lg'
    }) : /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Jumbo, {
                title: headerTitle,
                contents: description,
                imageUrl: phImageUrl,
                imageUrlFallback: phImageUrlFallback,
                imageUrlLarge: phImageUrlLarge,
                imageAlt: imageAlt,
                size: "small"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "container--lg align--center",
                children: /*#__PURE__*/ _jsxs("section", {
                    className: resultsClass,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "overview-filter",
                            children: /*#__PURE__*/ _jsx("ul", {
                                className: "overview-filter__list",
                                children: blogCategories.map((slug)=>/*#__PURE__*/ _jsx("li", {
                                        className: "overview-filter__item",
                                        children: /*#__PURE__*/ _jsx("button", {
                                            className: `overview-filter__link button ${selectedCategory == slug ? 'button--active' : ''}`,
                                            onClick: ()=>setCategory(slug),
                                            children: labels[slug]
                                        })
                                    }, `blogs_filter_item_${slug}`))
                            })
                        }),
                        posts.length > 0 ? /*#__PURE__*/ _jsx(Teasers, {
                            items: List(posts)
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "text--styled",
                            children: /*#__PURE__*/ _jsx("p", {
                                className: "weight--bold container--s",
                                children: "Op dit moment zijn er helaas geen blogs beschikbaar."
                            })
                        })
                    ]
                })
            }),
            pager
        ]
    }, key);
};
